import { setClientData } from '../util/clientData';
import { applyDateLocale } from '../util/dateLocale';
import dayjs from '../util/dayjs';
import { setAppRateLocale } from '../util/mobile/appRate';
import { isCordova } from '../util/mobile/deviceDetection';

// ================ Action types ================ //

// ================ Reducer ================ //

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  const { type } = action;
  switch (type) {
    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

// ================ Thunks ================ //

export const changeLocale = (newLocale, navigate, location) => (dispatch) => {
  applyDateLocale(newLocale);
  const currentPath = location.pathname;
  const hasLocaleInUrl = currentPath.match(/^\/[a-z]{2}(\/|$)/);
  const newPath = hasLocaleInUrl
    ? currentPath.replace(/^\/[a-z]{2}/, `/${newLocale}`)
    : `/${newLocale}${currentPath}`;

  //saving locale to local storage for cordova
  isCordova() && setClientData('vansite.locale', newLocale, dayjs().add(100, 'years'));

  setAppRateLocale(newLocale);

  navigate(newPath + location.search);

  // Force scroll reset — the browser can retain the scroll extent from the
  // previous (taller) page, leaving whitespace below shorter content.
  requestAnimationFrame(() => window.scrollTo(0, 0));
};
